// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const dudunsparce_three_segment: PokeData = {
  "id": 10255,
  "name": "dudunsparce-three-segment",
  "height": 45,
  "weight": 474,
  "base_experience": 182,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "double-edge",
    "screech",
    "defense-curl",
    "glare",
    "flail",
    "mud-slap",
    "rollout",
    "ancient-power",
    "yawn",
    "endeavor",
    "roost",
    "dragon-rush",
    "coil",
    "drill-run",
    "hurricane",
    "boomburst",
    "hyper-drill"
  ],
  "moves": [
    "mud-slap",
    "ancient-power",
    "roost",
    "dragon-rush",
    "hurricane",
    "supersonic",
    "scary-face",
    "tri-attack",
    "purification",
    "leer",
    "tackle",
    "quick-attack",
    "scratch"
  ],
  "evolution_chain": {
    "id": 103,
    "item": null,
    "species": [
      {
        "name": "dunsparce",
        "order": 237,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "dudunsparce",
        "order": 917,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 206,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "hyper-drill"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 158,
    "speed": 86,
    "ability_power": 156
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
